/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DownloadAndSignOptionsViewModel } from './DownloadAndSignOptionsViewModel';
import {
    DownloadAndSignOptionsViewModelFromJSON,
    DownloadAndSignOptionsViewModelFromJSONTyped,
    DownloadAndSignOptionsViewModelToJSON,
} from './DownloadAndSignOptionsViewModel';

/**
 * 
 * @export
 * @interface DownloadAndSignViewModel
 */
export interface DownloadAndSignViewModel {
    /**
     * 
     * @type {number}
     * @memberof DownloadAndSignViewModel
     */
    proposalId: number;
    /**
     * 
     * @type {string}
     * @memberof DownloadAndSignViewModel
     */
    additionalInstructions: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadAndSignViewModel
     */
    dateGenerated: string;
    /**
     * 
     * @type {DownloadAndSignOptionsViewModel}
     * @memberof DownloadAndSignViewModel
     */
    downloadAndSignOptions: DownloadAndSignOptionsViewModel;
}

/**
 * Check if a given object implements the DownloadAndSignViewModel interface.
 */
export function instanceOfDownloadAndSignViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "additionalInstructions" in value;
    isInstance = isInstance && "dateGenerated" in value;
    isInstance = isInstance && "downloadAndSignOptions" in value;

    return isInstance;
}

export function DownloadAndSignViewModelFromJSON(json: any): DownloadAndSignViewModel {
    return DownloadAndSignViewModelFromJSONTyped(json, false);
}

export function DownloadAndSignViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadAndSignViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'additionalInstructions': json['AdditionalInstructions'],
        'dateGenerated': json['DateGenerated'],
        'downloadAndSignOptions': DownloadAndSignOptionsViewModelFromJSON(json['DownloadAndSignOptions']),
    };
}

export function DownloadAndSignViewModelToJSON(value?: DownloadAndSignViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'AdditionalInstructions': value.additionalInstructions,
        'DateGenerated': value.dateGenerated,
        'DownloadAndSignOptions': DownloadAndSignOptionsViewModelToJSON(value.downloadAndSignOptions),
    };
}

